import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import useMobileLayout from 'Hooks/useMobileLayout';
import {
  FDStack,
} from '@facet-wealth/design';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';

const DescriptionsListMeta = ({
  collection,
}) => {
  const resources = collection?.resources()?.list();
  const isMobile = useMobileLayout();

  return (
    <FDStack direction={'column'} spacing={1} alignItems="flex-start" justifyContent="flex-start">
      {resources.map((resource) => {
        const description = resource.attr('description');
        return (
          <Typography
            variant={'h6'}
            weight={isMobile ? 'extraBold' : 'bold'}
            color={'darkGray'}
            key={resource.id()}
          >
            {description}
          </Typography>
        );
      })}
    </FDStack>
  );
};

DescriptionsListMeta.defaultProps = {
};

DescriptionsListMeta.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default DescriptionsListMeta;
